/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_IncompleteInputs */

const de__filter_incomplete = /** @type {(inputs: _Filter_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unvollständig`)
};

/**

* @param {_Filter_IncompleteInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _filter_incomplete = /** @type {((inputs?: _Filter_IncompleteInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_IncompleteInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_incomplete(inputs)
});